import AGREGAR_CONTRATO_PROGRAMA_OBRA from '@/graphql/mutations/administracion/contratos/contrato/programa/agregarContratoProgramaObra.gql';
import ACTUALIZAR_CONTRATO_PROGRAMA_OBRA from '@/graphql/mutations/administracion/contratos/contrato/programa/actualizarContratoProgramaObra.gql';
import REMOVER_CONTRATO_PROGRAMA_OBRA from '@/graphql/mutations/administracion/contratos/contrato/programa/removerContratoProgramaObra.gql';
import REMOVER_CONTRATO_PROGRAMA_OBRA_DETALLE from '@/graphql/mutations/administracion/contratos/contrato/programa/removerContratoProgramaObraDetalle.gql';
import CONTRATO_PROGRAMAS_OBRA from '@/graphql/querys/administracion/contratos/programa/contratoProgramasObra.gql';

export default {
  methods: {
    async mixAgregarPrograma() {
      this.mixEsCargando();
      this.enviadoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_PROGRAMA_OBRA,
          variables: {
            programa: this.programaDeObra,
          },
          update: (store, { data: { agregarContratoProgramaObra } }) => {
            // Query
            const query = {
              query: CONTRATO_PROGRAMAS_OBRA,
              variables: {
                idContrato: this.contrato.id,
              },
            };
            // Agregar nuevo programa
            const { contratoProgramasObra } = store.readQuery(query);
            const contratoProgramasObraCopia = contratoProgramasObra.slice().map((programa) => ({
              ...programa,
              esUltimo: false,
            }));
            contratoProgramasObraCopia.push(agregarContratoProgramaObra);
            // Actualizar la store
            store.writeQuery({
              ...query,
              data: {
                contratoProgramasObra: contratoProgramasObraCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviadoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixActualizarPrograma() {
      this.mixEsCargando();
      this.enviadoFormulario = true;
      const { idContrato, idContratoProgramaObra, programa } = this.programaDeObra;

      const datos = {
        id: idContratoProgramaObra,
        editarPrograma: programa.filter((item) => item.id)
          .map(({
            id,
            fechaInicio,
            fechaTermino,
            plazo,
            monto,
          }) => ({
            id,
            idContratoProgramaObra,
            fechaInicio,
            fechaTermino,
            plazo,
            monto,
          })),
        nuevoPrograma: programa.filter((item) => !item.id),
      };
      // Actualizar programa
      await this.$apollo.mutate({
        mutation: ACTUALIZAR_CONTRATO_PROGRAMA_OBRA,
        variables: {
          programa: datos,
        },
        update: (store, { data: { actualizarContratoProgramaObra } }) => {
          // Query
          const query = {
            query: CONTRATO_PROGRAMAS_OBRA,
            variables: {
              idContrato,
            },
          };
          const data = store.readQuery(query);
          // Encontrar el programa
          const index = data.contratoProgramasObra
            .findIndex((item) => item.id === idContratoProgramaObra);

          // Si el index existe
          if (index !== -1) {
            // Remover el programa
            data.contratoProgramasObra.splice(index, 1, actualizarContratoProgramaObra);
          }

          // Actualizar la store
          store.writeQuery({ ...query, data });
        },
      })
        .then(() => this.mixMensajeSuccess())
        .catch((err) => this.mixMensajeError(err));

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEliminarTodoPrograma() {
      this.mixEsCargando();
      this.enviadoFormulario = true;
      // Eliminar programa
      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_PROGRAMA_OBRA,
        variables: {
          id: this.idPrograma,
        },
        update: (store) => {
          // Query
          const query = {
            query: CONTRATO_PROGRAMAS_OBRA,
            variables: {
              idContrato: this.idContrato,
            },
          };
          const data = store.readQuery(query);
          // Encontrar el programa
          const index = data.contratoProgramasObra
            .findIndex(({ id }) => id === this.idPrograma);

          // Si el index existe
          if (index !== -1) {
            // Remover el programa
            data.contratoProgramasObra.splice(index, 1);
          }

          // Actualizar la store
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEliminarContratoPrograma() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_PROGRAMA_OBRA_DETALLE,
        variables: {
          id: this.programaObraEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_PROGRAMAS_OBRA,
            variables: {
              idContrato: this.idContrato,
            },
          };
          const data = store.readQuery(query);
          const { contratoProgramasObra } = data;
          const { programa } = contratoProgramasObra
            .find((programaDetalle) => programaDetalle.id
            === this.programaObraEliminar.idContratoProgramaObra);
          const index = programa
            .findIndex((programaDetalle) => programaDetalle.id === this.programaObraEliminar.id);
          if (index !== -1) {
            programa.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    seAgregoPrograma(programa) {
      const { importe } = this.contrato;
      const importeDelContrato = (importe + this.contrato.modificado.importe);
      // Validaciones
      if (programa.monto > (importeDelContrato)) {
        return;
      }
      this.programaDeObra.programa.push(programa);
    },
    remover(index) {
      this.programaDeObra.programa.splice(index, 1);
    },
  },
  computed: {
    importeContrato() {
      if (!this.contrato) return 0;
      if (this.contrato.esObraFinanciada) {
        return this.contrato.importeCostoDirecto;
      }
      return this.contrato.importe;
    },
    getTotalContratado() {
      if (!this.contrato) return 0;
      return this.$numberRound((this.importeContrato + this.getContratoImporteModificado));
    },
    getContratoImporteModificado() {
      if (this.contrato.esObraFinanciada) {
        return this.contrato.modificado.importeCostoDirecto;
      }

      return this.contrato.modificado.importe;
    },
    validarMonto() {
      return this.getTotalContratado === this.sumarMontos;
    },
    sumarMontos() {
      return this.$ObjSumar(this.programaDeObra.programa, 'monto');
    },
    sumarPlazos() {
      return this.$ObjSumar(this.programaDeObra.programa, 'plazo');
    },
    fechaInicio() {
      if (!this.contrato) return null;
      if (this.contrato.modificado.fechaInicio) return this.contrato.modificado.fechaInicio;
      return this.contrato.fechaInicio;
    },
    fechaTermino() {
      if (!this.contrato) return null;
      if (this.contrato.modificado.fechaTermino) return this.contrato.modificado.fechaTermino;
      return this.contrato.fechaTermino;
    },
    getFechaInicio() {
      // const rePrograma = this.programaDeObra.programa.map(
      //   (programa) => programa,
      // );
      const { programa: rePrograma } = JSON.parse(JSON.stringify(this.programaDeObra));

      if (rePrograma.length > 0) {
        const fechaTermino = new Date(`${rePrograma.pop().fechaTermino} 00:00:0`);
        const fechaInicio = new Date(fechaTermino.setDate(fechaTermino.getDate() + 1));
        const mesFormatoDosDigitos = (`0${(fechaInicio.getMonth() + 1)}`).slice(-2);
        const diaFormatoDosDigitos = (`0${fechaInicio.getDate()}`).slice(-2);

        return `${fechaInicio.getFullYear()}-${mesFormatoDosDigitos}-${diaFormatoDosDigitos}`;
      }

      return this.fechaInicio;
    },
  },
};
